import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

/**
 * Card container — replaces the manual `border border-border-subtle
 * rounded-sm p-md bg-bg-secondary` recipe scattered across pages.
 */
export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-sm border border-border-subtle bg-bg-secondary text-text-primary',
        className,
      )}
      {...props}
    />
  ),
);
Card.displayName = 'Card';
